import * as i0 from "@angular/core";
export class PrecioReferenciaService {
    constructor() { }
    GetPreciosReferencia() {
        return [
            { value: "99", label: "Último Precio de Costo" },
            { value: "1", label: "Lista precio 1" },
            { value: "2", label: "Lista precio 2" },
            { value: "3", label: "Lista precio 3" },
            { value: "4", label: "Lista precio 4" },
            { value: "5", label: "Lista precio 5" },
        ];
    }
}
PrecioReferenciaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PrecioReferenciaService_Factory() { return new PrecioReferenciaService(); }, token: PrecioReferenciaService, providedIn: "root" });
